import bugsnag from 'bugsnag-js';

export const bugsnagClient = bugsnag({
  apiKey: window.BUGSNAG_API_KEY || 'development',
  releaseStage: window.APP_ENV,
  notifyReleaseStages: ['production', 'staging'],
  autoCaptureSessions: window.APP_ENV !== "development"
});
